// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1WrX-","alert":"SettungsInbox_alert__3Bcok"};